export default "__VITE_ASSET__ok2RVTWR__"